import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useSchadenKICredentials } from "@/hooks/useSchadenKICredentials";
import { useTranslation } from "react-i18next";
import { Loading } from "@/components/ui/loading";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function SchadenKICredentialsInput() {
  const { t } = useTranslation();
  const {
    apiKey,
    apiUrl,
    isLoading,
    showApiKey,
    handleApiKeyChange,
    handleApiUrlChange,
    toggleApiKeyVisibility,
    handleSaveCredentials,
  } = useSchadenKICredentials();

  return (
    <div className="space-y-4">
      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="schaden-ki-api-key">{t("schadenKI.apiKey")}</Label>
        </div>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleSaveCredentials();
          }}
        >
          <div className="flex gap-2">
            <Input
              id="schaden-ki-api-key"
              type={showApiKey ? "text" : "password"}
              value={apiKey}
              onChange={handleApiKeyChange}
              disabled={isLoading}
              placeholder={t("schadenKI.apiKeyPlaceholder")}
              className="flex-1"
            />
            <Button
              type="button"
              onClick={toggleApiKeyVisibility}
              variant="ghost"
              size="icon"
              disabled={isLoading}
            >
              {showApiKey ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </Button>
          </div>
        </form>
        {isLoading && <Loading />}
      </ControlWrapper>

      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="schaden-ki-api-url">{t("schadenKI.apiUrl")}</Label>
        </div>
        <Input
          id="schaden-ki-api-url"
          type="text"
          value={apiUrl}
          onChange={handleApiUrlChange}
          disabled={isLoading}
          placeholder="https://your-api-endpoint.example.com"
        />
        <p className="text-xs text-muted-foreground mt-1">
          Nur die Base URL ohne Endpoint-Pfad (z.B. ohne /v1/claimstatus)
        </p>
      </ControlWrapper>
    </div>
  );
}

